import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeCreatePrescriptionMutation as useDeCreatePrescriptionMutationType } from "@/modules/patients/detail/prescription/de/services/__generated__/useDeCreatePrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeCreatePrescriptionMutation($input: De_createPrescriptionInput!) {
    de_createPrescription(input: $input) {
      de_Prescription {
        id
        ...dePrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeCreatePrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeCreatePrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCreatePrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeCreatePrescriptionMutation }
